import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function DMM_Mobile_view_faq_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='pb-4'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-6'>Can social media marketing really help my business?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Most honestly! It’s been established again and again by commercial enterprise after commercial enterprise. In fact, no longer making use of social media marketing can definitely damage your enterprise, considering the fact that having an online presence on social media is honestly expected of any reputable firm in recent times.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What are the benefits of social media marketing for my company?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Whether or not your business is taking benefit of it or no longer, social media has all the time modified the manner that clients talk with companies, and vice versa. Being handy for your clients – and your prospective clients – thru social media is a critical method of growing relationships with them and assisting them through the sales funnel. 
          <br></br>  
          <ul>
            <li>Java: It has always been a starting point for new developers and used by the majority of people who work with Android development. Eclipse, NetBeans, and IntelliJ IDE are the most popular IDE’s(Integrated Development Environment) used for developing an Android application using java.</li>
            <li>Kotlin: Kotlin is a relatively new, modern, safe, and object-oriented cross-platform programming language used in developing an Android application. IDE’s used with kotlin are Android studio, Eclipse IDE, etc.</li>
          </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>How should companies measure their social media marketing success?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Success is measured using the same metrics you use for any other marketing activity: traffic, leads, and customers. Counting the number of fans or followers you have can help you understand your social media reach, but the bottom line that determines its success is how many people it drives to your site, how many of them are qualified leads, and how many of them actually become customers.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
    </div>
  );
}
